<template>
  <div>
      {{sLabel ==='' ? `Mapa` : sLabel}}
  </div>
</template>

<script>
import mixin from '@/mixins/BuildCorreoComponentes.js'
  export default {
    name:"Mapa",
    mixins:[mixin],
    data() {
      return {
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>